<template>
  <div class="footer">
    <div class="bg-secondary text-white d-none d-sm-block">
      <div class="container-lg">
        <div class="py-4">
          <div class="fs-thirdly text-center text-sm-start mb-3">
            {{ footTitle }}
          </div>
          <div class="row g-3 lh-sm justify-content-center justify-content-sm-start">
            <div v-if="brandSiteListBriefLoading" class="placeholder-glow">
              <span class="placeholder col-4"></span>
            </div>
            <div
              v-else
              v-for="item in items"
              :key="item.id"
              class="col-auto d-flex"
            >
              <a
                class="text-white"
                :href="`https://${item.url}`"
                target="_blank"
                rel="noopener"
              >
                {{ item.title }}
              </a>
              <div class="d-none d-sm-block h-100 opacity-75 vr ms-3"></div>
            </div>
            <div v-if="!brandSiteListBriefLoading" class="col-auto d-flex">
              <router-link class="text-white" to="/privacy-policy">會員隱私權條款</router-link>
            </div>
          </div>
        </div>
        <hr class="my-0" />
        <div class="d-sm-flex text-center text-sm-start py-3">
          <div class="row gy-3 fs-14px">
            <div class="col-sm-auto">© 2023 TSC Technologies Inc.</div>
          </div>
          <div class="row gx-3 text-light ms-auto mt-4 mt-sm-0 justify-content-center fs-18px">
            <div class="col-auto">
              <a class="text-white" :href="fbUrl" target="_blank"><i class="bi bi-facebook"></i></a>
            </div>
            <div class="col-auto">
              <a class="text-white" :href="igUrl" target="_blank"><i class="bi bi-instagram"></i></a>
            </div>
            <div class="col-auto">
              <a class="text-white" :href="lineUrl" target="_blank"><i class="bi bi-line"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
     <FooterMobile v-if="$route.meta.needFooter" />
  </div>
</template>

<script>
import FooterMobile from '@/components/FooterMobile'
import { GetBrandSiteListBrief } from '@/api/brand'
import { getSiteId, getBrandId } from '@/utils/auth'

export default {
  name: 'Footer',
  components: { FooterMobile },
  data() {
    return {
      brandId: getBrandId(),
      siteId: getSiteId(),
      items: [],
      footTitle: '',
      fbUrl: '',
      igUrl: '',
      lineUrl: '',
      brandSiteListBriefLoading: true
    }
  },
  mounted() {
    this.fetchBrandSiteListBrief()
  },
  methods: {
    async fetchBrandSiteListBrief() {
      await GetBrandSiteListBrief(this.brandId, this.siteId)
        .then((result) => {
          const { data } = result
          this.items = data.sites
          this.footTitle = data.title
          this.fbUrl = data.facebookUrl
          this.igUrl = data.instagramUrl
          this.lineUrl = data.lineUrl
        })
        .finally(() => {
          this.brandSiteListBriefLoading = false
        })
    }
  }
}
</script>

<style>
:root {
  --mobile-footer-height: 63px;
}

.mobile-footer-height {
  height: var(--mobile-footer-height);
}

.more-tabs-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--bs-secondary-rgb), 0.2);
  z-index: 1035;
  backdrop-filter: blur(2px);
}

.mobile-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1040;
  width: 100%;
  background-color: white;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
  box-shadow: 0 1px 5px 0 rgba(9, 30, 66, 0.3);
}

.mobile-footer a {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 300;
  color: var(--bs-secondary);
}

.mobile-footer a.active {
  font-weight: 400;
  color: var(--bs-primary-600);
}

.mobile-footer a i {
  font-size: 16px;
  margin-bottom: 0.125rem;
}

.more-tabs {
  position: absolute;
  bottom: calc(100% + 0.5rem);
  right: 0.75rem;
}

.more-tabs-box {
  width: 70px;
  background-color: #fff;
  padding: 0.75rem 0.25rem;
  text-align: center;
  box-shadow: 0 1px 5px 0 rgba(9, 30, 66, 0.3);
  border-radius: 50rem;
}

.more-tabs-box a {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.qrcode-position {
  position: absolute;
  bottom: calc(100% + 0.5rem);
  right: 5px;
}

.btn.btn-qrcode {
  --bs-btn-color: #000;
  --bs-btn-bg: var(--bs-primary);
  --bs-btn-border-color: var(--bs-primary);
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: var(--bs-primary);
  --bs-btn-focus-shadow-rgb: var(--bs-primary-rgb);
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: var(--bs-primary-500);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: var(--bs-primary);
  --bs-btn-disabled-border-color: var(--bs-primary);

  --bs-btn-padding-x: 0;
  --bs-btn-padding-y: 0;
  --bs-btn-border-width: 0;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 50%;
  display: inline-flex;
  --bs-btn-font-size: 1.5rem;
}
</style>
